import { t } from '@/infra/i18n';

export function SplashScreen() {
  return (
    <div role="status" aria-live="polite" style={overlay} data-testid="splash-screen">
      <div style={card}>
        <h1 style={title}>Himotchi</h1>
        <p style={subtitle}>{t('splash.subtitle')}</p>
        <div aria-hidden="true" style={spinner} />
        <span style={loadingLabel}>{t('splash.loading')}</span>
      </div>
    </div>
  );
}

const overlay: React.CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: '#0a0a0a',
  display: 'grid',
  placeItems: 'center',
  zIndex: 1000,
};

const card: React.CSSProperties = {
  textAlign: 'center',
  color: '#f0f0f0',
  padding: 32,
};

const title: React.CSSProperties = {
  margin: '0 0 8px 0',
  fontSize: '2.4rem',
  color: '#ffd6b3',
  fontFamily: 'system-ui, sans-serif',
  fontWeight: 800,
  letterSpacing: '0.05em',
};

const subtitle: React.CSSProperties = {
  margin: '0 0 24px 0',
  fontSize: '0.95rem',
  color: '#999999',
};

const spinner: React.CSSProperties = {
  display: 'inline-block',
  width: 32,
  height: 32,
  borderRadius: '50%',
  border: '3px solid #2a2a3e',
  borderTopColor: '#ffd6b3',
  animation: 'spin 1s linear infinite',
};

const loadingLabel: React.CSSProperties = {
  display: 'block',
  marginTop: 12,
  fontSize: '0.85rem',
  color: '#666666',
};

const styleSheet = `
@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@media (prefers-reduced-motion: reduce) {
  [data-testid="splash-screen"] [aria-hidden="true"] {
    animation: none !important;
  }
}
`;

if (typeof document !== 'undefined') {
  const id = 'splash-styles';
  if (!document.getElementById(id)) {
    const tag = document.createElement('style');
    tag.id = id;
    tag.textContent = styleSheet;
    document.head.appendChild(tag);
  }
}
